import { render, staticRenderFns } from "./incomeRecord.vue?vue&type=template&id=8b5c7d28&scoped=true"
import script from "./incomeRecord.vue?vue&type=script&lang=js"
export * from "./incomeRecord.vue?vue&type=script&lang=js"
import style0 from "./incomeRecord.vue?vue&type=style&index=0&id=8b5c7d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5c7d28",
  null
  
)

export default component.exports